import { useEffect, EffectCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';

const usePageView = (fn: EffectCallback, skipFirstLoad: false): void => {
  const [firstLoad, setFirstLoad] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const isTrigered = !firstLoad || !skipFirstLoad;
    setFirstLoad(false);

    if (isTrigered) {
      return fn();
    }
  }, [location]); //eslint-disable-line
};

export default usePageView;
